// extracted by mini-css-extract-plugin
export default {"sliderContainer":"styles_sliderContainer__Cmowj"};